// src/components/map/utils/timelineBubbles.ts
//
// Pure helper that builds GeoJSON circle features from timeline bubble data.
// Extracted from Timeline.tsx to keep the component thin and the logic testable.
import turfCircle from "@turf/circle";

import { BubbleData } from "api/useTimeline";

/**
 * Converts an array of {@link BubbleData} items into turf circle features
 * suitable for rendering as a GeoJSON source on a Mapbox map.
 *
 * Items whose `location` array is empty are silently skipped.
 */
export function buildBubbleFeatures(
  bubbles: ReadonlyArray<BubbleData>
): GeoJSON.Feature[] {
  const features: GeoJSON.Feature[] = [];

  for (const item of bubbles) {
    if (item.location.length === 0) {
      continue;
    }

    const circleFeat = turfCircle(item.location, item.size, {
      units: "meters",
      properties: {
        Uwi: item.uwi,
        color: item.color
      }
    });

    features.push(circleFeat);
  }

  return features;
}
